import { render, staticRenderFns } from "./NavMenuGreetingCards.vue?vue&type=template&id=1b5f947d"
import script from "./NavMenuGreetingCards.vue?vue&type=script&lang=js"
export * from "./NavMenuGreetingCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports